import { TableField } from "../../table-field";

export const fieldsLegCancelar: TableField[] = [
  {
    key: "Legislacao",
    label: "Legislação envolvida",
    tdClass: ["align-middle", "quebrarPorPalavra"],
    thClass: ["text-center", "quebrarPorPalavra"],
    sortable: true,
  },
  {
    key: "Entrega",
    label: "Entrega",
    tdClass: ["align-middle", "quebrarPorPalavra"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
  },
  {
    key: "DataEntrega",
    label: "Data da Entrega",
    tdClass: ["align-middle", "naoQuebrar"],
    thClass: ["text-center", "quebrarPorPalavra"],
    sortable: true,
  },
];